"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFromChownowApi = getFromChownowApi;
exports.postToChownowApi = postToChownowApi;
exports.apiRequest = apiRequest;

require("core-js/modules/es.promise.js");

var _index = require("../url/index.js");

const _excluded = ["endpoint"],
      _excluded2 = ["endpoint"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const CLIENT_TYPES = {
  'Direct-Web': 'direct_web'
};
const packages = {
  marketplaceWeb: 'Marketplace-Web',
  yelpWeb: 'Yelp-Web'
}; // Method for making GET requests to chownow API.
// Properly formats requests for different domains.

async function getFromChownowApi(endpoint) {
  const _apiRequest = apiRequest(endpoint),
        {
    endpoint: formattedEndpoint
  } = _apiRequest,
        options = _objectWithoutProperties(_apiRequest, _excluded);

  let data, error;

  try {
    const response = await fetch(formattedEndpoint, options);

    if (response.status === 404) {
      error = {
        message: 'Error fetching resource'
      };
      return {
        data,
        error
      };
    }

    data = await response.json();
  } catch (e) {
    error = e;
  }

  return {
    data,
    error
  };
} // Method for making POST requests to chownow API.
// Properly formats requests for different domains.


async function postToChownowApi(endpoint, body) {
  const _apiRequest2 = apiRequest(endpoint, body, 'POST'),
        {
    endpoint: formattedEndpoint
  } = _apiRequest2,
        options = _objectWithoutProperties(_apiRequest2, _excluded2);

  try {
    const response = await fetch(formattedEndpoint, options);
    const {
      status
    } = response;
    const data = await response.json();

    switch (status) {
      case 404:
        return {
          data: null,
          error: {
            message: 'Error fetching resource'
          }
        };

      case 400:
        // 400 responses do not cause fetch to throw
        // in this case the "data" should be reassigned as an error
        return {
          error: data,
          data: null
        };

      default:
        return {
          error: null,
          data
        };
    }
  } catch (e) {
    return {
      data: null,
      error: e
    };
  }
}

function getPackage() {
  if ((0, _index.isMarketplacePlatform)()) {
    return packages.marketplaceWeb;
  } else if ((0, _index.isYelpPlatform)()) {
    return packages.yelpWeb;
  }

  return process.env.REACT_APP_PACKAGE || process.env.NEXT_PUBLIC_PACKAGE;
} // Formatting function that returns an object formatted for the Fetch API


function apiRequest(path, params) {
  let method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
  let customHost = arguments.length > 3 ? arguments[3] : undefined;
  let apiVersion = arguments.length > 4 ? arguments[4] : undefined;
  let apiHost = process.env.REACT_APP_API_HOST || process.env.NEXT_PUBLIC_API_HOST;
  const reactPackage = getPackage();

  if (process.env.NODE_ENV === 'test') {
    apiHost = 'https://eat.dev.chownow.com/api';
  }

  const endpoint = customHost ? "".concat(customHost, "/").concat(path) : "".concat(apiHost, "/").concat(path);
  let finalParams = params || {};
  const meta = finalParams.meta || {};
  const version = apiVersion || '3.0';
  const headers = {
    Accept: "application/json version=".concat(version, ";"),
    'Content-Type': 'application/json; charset=UTF-8',
    'X-CN-App-Info': "".concat(reactPackage, "/").concat(process.env.NEXT_PUBLIC_APP_VERSION || process.env.REACT_APP_VERSION || process.env.VERSION)
  }; // Short circuit any GET requests regardless of domain

  if (method.toUpperCase() === 'GET') {
    return {
      credentials: 'include',
      method,
      headers,
      endpoint: Object.keys(finalParams || {}).length ? "".concat(endpoint, "?").concat((0, _index.param)(finalParams)) : endpoint
    };
  } // If we are serving the marketplace-themed Order Direct experience, then
  // we want to report Marketplace analytics


  if ((0, _index.isMarketplacePlatform)()) {
    const {
      channel
    } = meta;
    finalParams = _objectSpread(_objectSpread({}, finalParams), {}, {
      meta: {
        marketplace: {
          id: '2',
          x_id: null
        },
        channel
      }
    });
    return {
      credentials: 'include',
      method,
      headers,
      endpoint,
      body: JSON.stringify(finalParams)
    };
  } // If we are serving yelp-themed Order Direct experience, we need to read the
  // opportunity token from the payload, and place it within the meta property.
  // x_id is the opporuntity


  if ((0, _index.isYelpPlatform)() && finalParams.opportunity_token) {
    finalParams = _objectSpread(_objectSpread({}, finalParams), {}, {
      meta: {
        marketplace: {
          id: '1',
          x_id: params.opportunity_token
        }
      }
    }); // After moving it to the meta object, the opportunity token can be
    // deleted.

    delete finalParams.opportunity_token;
    return {
      credentials: 'include',
      method,
      headers,
      endpoint,
      body: JSON.stringify(finalParams)
    };
  } // Catch any Order Direct calls that don't have a client_type key set


  if (CLIENT_TYPES[reactPackage] && !meta.client_type) {
    finalParams = _objectSpread(_objectSpread({}, finalParams), {}, {
      meta: _objectSpread(_objectSpread({}, meta), {}, {
        client_type: CLIENT_TYPES[reactPackage]
      })
    });
    return {
      credentials: 'include',
      method,
      headers,
      endpoint,
      body: JSON.stringify(finalParams)
    };
  }

  return {
    credentials: 'include',
    method,
    headers,
    endpoint,
    body: JSON.stringify(finalParams)
  };
}